import { useAuth } from "@/components/Auth";
import { LoadingOverlay } from "@mantine/core";
import { useEffect } from "react";
import { Navigate, useParams } from "react-router";

const LoginRedirect = () => {
    const { code } = useParams();
    const {loginRedirect, currentUser} = useAuth();
    useEffect(() => {
        if(code){
            loginRedirect({code: code as string});
        }
    }, [code])
    useEffect(() => {
        document.title = "Logging In - Guard Dog Real Estate Protection Service";
    }, []);
    return (
        <>
            <LoadingOverlay visible={true} overlayProps={{blur: 2, radius: 'sm'}} loaderProps={{size: 'xl'}}></LoadingOverlay>
            {currentUser ? <Navigate to="/dashboard" /> : null}
        </>
    )
}
export default LoginRedirect;